import { createSelector } from '@reduxjs/toolkit';

export const selectConfig = (state) => state.config;

export const selectStartTime = createSelector(
  selectConfig,
  (config) => config.time,
);
